import { PropTypes } from 'prop-types';
import path from 'ramda/src/path';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Icon, Icons } from '@ge/components/icon';

const PanelNavWrapper = styled.nav`
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  span {
    text-transform: uppercase;
  }
`;

const PanelNavActions = styled.div`
  position: absolute;
  right: 5px;
  top: 10px;

  .popout & {
    right: 15px;
    top: 6px;
  }
`;

const PanelNavHistory = styled.div`
  position: absolute;
  left: 10px;
  top: 10px;
`;

const ChevronIcon = styled(Icon).attrs((props) => ({
  size: 10,
  icon: Icons.CHEVRON,
  color: props.color || props.theme.entityDetails.headerIconColor,
  rotate: 90,
}))``;

const CloseIcon = styled(Icon).attrs((props) => ({
  size: 10,
  icon: Icons.CLOSE,
  color: props.color ? props.color : props.theme.entityDetails.headerIconColor,
}))``;

const WindowIcon = styled(Icon).attrs((props) => ({
  size: 10,
  icon: Icons.NEW_WINDOW,
  color: props.color ? props.color : props.theme.entityDetails.headerIconColor,
}))``;

const PanelNav = ({ color, closePanel, disableHistory, entityId, spawnWindow, onHistoryBack }) => {
  const history = useHistory();
  const hasHistory = () => path(['location', 'state', 'initial'], history) === false;

  // Don't render if there's no entity
  if (!entityId) {
    return null;
  }

  return (
    <PanelNavWrapper>
      <PanelNavHistory>
        {hasHistory() && !disableHistory && (
          <button type="button" onClick={onHistoryBack}>
            <ChevronIcon color={color} />
          </button>
        )}
      </PanelNavHistory>
      <PanelNavActions>
        {spawnWindow && (
          <button type="button" onClick={spawnWindow}>
            <WindowIcon color={color} />
          </button>
        )}
        {closePanel && (
          <button type="button" onClick={closePanel}>
            <CloseIcon color={color} />
          </button>
        )}
      </PanelNavActions>
    </PanelNavWrapper>
  );
};

PanelNav.propTypes = {
  color: PropTypes.string,
  closePanel: PropTypes.func,
  disableHistory: PropTypes.bool,
  entityId: PropTypes.string.isRequired,
  spawnWindow: PropTypes.func,
  onHistoryBack: PropTypes.func,
};

PanelNav.defaultProps = {
  color: null,
  disableHistory: false,
  spawnWindow: null,
  closePanel: null,
  onHistoryBack: () => {},
};

export default PanelNav;
